import React from "react";
import "./Industries.css";
import Industriesslider from "./Industry-slider";
const Industries = () => {
  return (
    <div className="industries text-center" id="industries">
      <div className="container">
        <h6>Industries We Serve</h6>
        <h1>Turning Pain-points into Solutions across Diverse Sectors</h1>
        <Industriesslider/>
      </div>
    </div>
  );
};

export default Industries;
